export default "__VITE_ASSET__BHjUfGY7__"